import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  pagination: {
    borderTop: "1px solid " + colors.lightGrey,
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    padding: "16px 24px",
    "& ul": {
      listStyleType: "none",
      display: "flex",
      padding: 0,
      margin: 0,
      "& li": {
        fontWeight: "500",
        fontSize: "14px",
        cursor: "pointer",
        color: colors.mediumGrey,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& a": {
          padding: "8px 15px"
        },
        "&.selected": {
          color: colors.inactiveLightGrey,
          backgroundColor: colors.brightBlue,
          borderRadius: "8px",
        },
        "&.disabled": {
          backgroundColor: colors.white,
          boxShadow: "none",
          pointerEvents: "none"
        },
        "&:hover": {
          color: colors.grey,
          backgroundColor: colors.brightBlue,
          borderRadius: "8px",
        }
      }
    }
  },
  navItem: {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    "& a": {
      display: "inline-flex",
      alignItems: "center",
      color: colors.mediumGrey,
      textDecoration: "none",
      padding: "0 !important"
    },
    "&.disabled": {
      "& a": {
        color: colors.darkGrey
      }
    }
  },
  next: {
    extend: "navItem",
    marginLeft: "auto",
    userSelect: "none",
    "& a": {
      color: colors.mediumGrey,
      "&:hover": {
        color: colors.grey
      },
    },
    "& svg": {
      marginLeft: "8px",
      color: colors.mediumGrey,
      "& path": {
        "&:hover": {
          stroke: colors.grey
        },
      },
    },
    "&:hover": {
      backgroundColor: `${colors.white} !important`,
      color: colors.grey,
    },
  },
  prev: {
    extend: "navItem",
    marginRight: "auto",
    userSelect: "none",
    "& a": {
      color: colors.mediumGrey,
      "&:hover": {
        color: colors.grey
      },
    },
    "& svg": {
      marginRight: "8px",
      color: colors.mediumGrey,
      "& path": {
        "&:hover": {
          stroke: colors.grey
        },
      },
    },
    "&:hover": {
      backgroundColor: `${colors.white} !important`,
      color: colors.grey,
    },
  },
  mobilePagination: {
    display: "flex",
    borderTop: "1px solid " + colors.lightGrey,
    padding: "16px 24px",
    "& span":{
      display: "flex",
      alignItems:"center"
    }
  },
  navItemMobile: {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    padding: "7px 10px",
    "&.disabled": {
      pointerEvents: "none",
    }
  },
  mobileNext: {
    extend: "navItemMobile",
    marginLeft: "auto"
  },
  mobilePrev: {
    extend: "navItemMobile",
    marginRight: "auto"
  },
  paginationContent: {
    display: "flex",
    alignItems: "center",
  },
}));

export default styles;
